// Format an event's calendar day in its own venue IANA timezone (not the viewer's or
// server's), so a late-night UTC instant rolls to the correct local day. Falls back to
// the viewer's local zone when no valid IANA zone is available (legacy records).
export function formatEventDate(iso, timeZone, opts) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const options = opts || { weekday: "short", month: "short", day: "numeric", year: "numeric" };
  try {
    return new Intl.DateTimeFormat("en-US", { ...options, timeZone }).format(d);
  } catch (_) {
    return new Intl.DateTimeFormat("en-US", options).format(d);
  }
}
